import React, { CSSProperties } from 'react';
import styled from 'styled-components';

export interface Props {
  style?: CSSProperties;
  text: string;
}

const color = '#b22a2a';
const Message = styled.div`
  border: 1px solid ${color};
  border-radius: .3rem;
  color: ${color};
  font-size: .95rem;
  letter-spacing: .02rem;
  padding: .5rem 1rem;
`;

export const FormValidationMessage = (props: Props) => {
  const { text, style } = props;
  return (
    <Message style={style}>{text}</Message>
  );
};
